import type { ReactNode } from "react";
import type { MoreToolIcon } from "lib/moreToolsData";

type IconProps = { className?: string };

function SvgShell({
  className,
  children,
  label,
}: {
  className?: string;
  children: ReactNode;
  label: string;
}) {
  return (
    <svg className={className} viewBox="0 0 64 64" role="img" aria-label={label}>
      {children}
    </svg>
  );
}

export function MoreToolIconSvg({
  icon,
  className,
  label,
}: {
  icon: MoreToolIcon;
  className?: string;
  label: string;
}) {
  const props: IconProps = { className };
  switch (icon) {
    case "tgsend":
      return (
        <SvgShell {...props} label={label}>
          <g className="i-tgsend">
            <g className="plane2">
              <path d="M8 32 L54 13 L44 51 L34 37 Z" />
              <path d="M34 37 L54 13" />
            </g>
            <g className="streak">
              <line x1="4" y1="24" x2="16" y2="24" />
              <line x1="2" y1="32" x2="18" y2="32" />
              <line x1="4" y1="40" x2="14" y2="40" />
            </g>
          </g>
        </SvgShell>
      );
    case "video":
      return (
        <SvgShell {...props} label={label}>
          <g className="i-video">
            <rect x="9" y="13" width="46" height="29" rx="5" />
            <path className="play fillc" d="M27 21 L40 27.5 L27 34 Z" />
            <rect className="fillc" x="9" y="49" width="46" height="4" rx="2" opacity=".22" />
            <rect className="fill fillc" x="9" y="49" width="46" height="4" rx="2" />
          </g>
        </SvgShell>
      );
    case "translate":
      return (
        <SvgShell {...props} label={label}>
          <g className="i-translate">
            <circle cx="32" cy="32" r="19" />
            <path d="M13 32 h38 M32 13 v38" />
            <path d="M32 13 a19 11 0 0 0 0 38 a19 11 0 0 0 0 -38" />
            <circle className="orbit fillc" cx="51" cy="32" r="3" />
            <text className="g1" x="32" y="38" textAnchor="middle">
              A
            </text>
            <text className="g2" x="32" y="38" textAnchor="middle">
              अ
            </text>
          </g>
        </SvgShell>
      );
    case "shield":
      return (
        <SvgShell {...props} label={label}>
          <g className="i-shield">
            <path
              className="body"
              d="M32 7 L53 15 V31 C53 44 44 52 32 57 C20 52 11 44 11 31 V15 Z"
            />
            <path d="M24 32 Q32 24 40 32 Q32 40 24 32 Z" />
            <circle className="fillc" cx="32" cy="32" r="2.4" />
            <line className="sweep" x1="12" y1="22" x2="52" y2="22" opacity=".7" />
          </g>
        </SvgShell>
      );
    default:
      return null;
  }
}
